/**
 * Thin re-export module.
 *
 * S3UploadProgress is consumed by:
 *   - features/upload/components/media-recorder.tsx:12
 *   - features/upload/components/recorder/upload-progress.tsx:5
 * Both imports must remain until those files migrate to cognito-upload.ts directly.
 *
 * sanitizeFileName is consumed by features/upload/hooks/use-upload.ts:21.
 * It is an alias to the canonical sanitizeUploadFileName in cognito-upload.ts.
 *
 * Full deletion of this module is deferred until all consumers migrate.
 */
import { sanitizeUploadFileName, type S3UploadProgress } from "./cognito-upload";

export type { S3UploadProgress };

export function sanitizeFileName(name: string, extension: string): string {
  return sanitizeUploadFileName(name, extension);
}
